import { minimumsTable } from '@features/lci-report/slides/appendix/lci-guideline-minimums/components/minimums-table';
import {
  emptyLine,
  householdsText,
  notesOptions,
} from '@features/lci-report/slides/appendix/lci-guideline-minimums/components/notes';
import { categoryLabels } from '@features/lci-report/slides/appendix/lci-guideline-minimums/medium/components/category-labels';
import { columnLabels } from '@features/lci-report/slides/appendix/lci-guideline-minimums/medium/components/column-labels';
import { mediumSlide } from '@features/lci-report/slides/appendix/lci-guideline-minimums/medium/slide';
import { Slide } from '@features/powerpoint';

type MinimumRow = { name: string; minimum: string };

const rows = [
  {
    name: categoryLabels.digitalLciMobileApp,
    minimum: '15M Impressions',
  },
  {
    name: categoryLabels.digitalLciMobileWeb,
    minimum: '35M Impressions',
  },
  {
    name: categoryLabels.digitalLciConnectedTv,
    minimum: '20M Impressions',
  },
  {
    name: categoryLabels.tvLciLinear,
    minimum: '25M HHs',
  },
  {
    name: categoryLabels.oohLci,
    minimum: '~5M Users',
  },
  {
    name: categoryLabels.directMail,
    minimum: '1-2M HHs',
  },
] as const satisfies readonly MinimumRow[];

export const minimumsSlide = (): Slide => {
  return mediumSlide({
    buildNotes: ({ options }) => ({
      texts: [
        {
          text: [
            {
              text: '*Note: Feasibility assessment is required by InMarket Measurement Team.',
              options: {
                breakLine: true,
              },
            },
            emptyLine,
            householdsText,
            {
              text: '**Minimum Campaign Flight = 4 weeks',
            },
          ],
          options: {
            ...notesOptions,
            ...options,
          },
        },
      ],
    }),
    table: minimumsTable({
      data: {
        headers: [columnLabels.name, columnLabels.attributionMinimums],
        body: rows.map(row => [row.name, row.minimum]),
      },
      options: {
        rowH: 0.3,
        x: 2.27,
        y: 1.89,
        w: 8.39,
      },
    }),
  });
};
